import type { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { mergeWith } from "lodash";
import { useCallback } from "react";
import type { ExcelReportTemplate } from "../excel-report-template";
import { saveBlob } from "../excel-report-template/helper";

type ExportExcelParam = {
  fileName?: string;
  template: ExcelReportTemplate;
  data: any | any[];
};

type ExportExcelOption = {
  multipleSheet?: boolean;
};

const useExportExcel = () => {
  const exportExcel = useCallback(async (params: ExportExcelParam, options?: ExportExcelOption) => {
    try {
      const { data, template, fileName = "excel" } = params;

      const createWorkBook = (await import("../excel-report-template")).default[template];

      let wb: Workbook;

      if (Array.isArray(data)) {
        if (options?.multipleSheet) {
          /** Multiple sheet */
          wb = data.reduce(
            (wb, item, index) => createWorkBook({ wb, data: item, sheetName: `Sheet${index + 1}` }),
            undefined
          );
        } else {
          /** All in 1 sheet */
          const mergeData = mergeWith({}, ...data, (objValue: any, srcValue: any) => {
            try {
              const obj = JSON.parse(objValue);
              const src = JSON.parse(srcValue);
              
              if (Array.isArray(obj)) {
                return JSON.stringify(obj.concat(src));
              }
            } catch (error) {}
          });

          wb = createWorkBook({ data: mergeData });
        }
      } else {
        wb = createWorkBook({ data });
      }

      const blob = await saveBlob(wb);

      saveAs(blob, `${fileName}.xlsx`);
    } catch (error) {
      console.error(error);
    }
  }, []);

  return exportExcel;
};

export default useExportExcel;
